import { HighPrioritySchoolIndicator } from '@/components/high-priority-school-indicator.js';

interface SchoolPageTitleProps {
  name: string;
  isHighPriority?: boolean | null;
}

export function SchoolPageTitle({ name, isHighPriority }: SchoolPageTitleProps) {
  return (
    <span className="inline-flex items-center gap-2">
      {name}
      <HighPrioritySchoolIndicator isHighPriority={isHighPriority} data-testid="school-header-icon-high-priority" />
    </span>
  );
}
